import { render, staticRenderFns } from "./detailHandle.vue?vue&type=template&id=6136c50d&scoped=true&"
import script from "./detailHandle.vue?vue&type=script&lang=js&"
export * from "./detailHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136c50d",
  null
  
)

export default component.exports